import { fetchedConfirmAuthNumber, fetchedConfirmId, fetchedFindId, fetchedLoginUserData, fetchedSendAuthNumber, fetchedUpdatePassword } from '@/api/api.login'
import ApiUtil from '../api/api.util'
import ApiConfig from '../api/api.config'
const platformDomain = ApiConfig.platformDomain
const singleDomain = ApiConfig.singleDomain


const urlStoreModule = {
  state    : {
    url  : [],
    errors : null
  },
  getters  : {
    fetchedUrlData (state) {
      return state.url
    }
  },
  mutations: {
    SET_URL_DATA (state, urlData) {
      state.url = urlData
      sessionStorage.setItem('platformDomain',urlData['00012']) //  기준으로 00001에서 00012로 변경. 2020. 04. 20. oxide.
      sessionStorage.setItem('singleDomain',urlData['00006'])
      sessionStorage.setItem('ssoDomain',urlData['00002'])
      sessionStorage.setItem('conciergeDomain',urlData['00003'])
      sessionStorage.setItem('gewDomain',urlData['00010'])
      sessionStorage.setItem('tnaDomain',urlData['00005'])
      sessionStorage.setItem('gewApiDomain',urlData['00004'])
    },
    SET_URL_ERROR (state, error) {
      state.urlErrors = error
      kendo.alert(error)
    },
  },
  actions  : {
    FETCH_URL (context) {
      return new Promise(resolve => {
        ApiUtil.get(`${singleDomain}/v1/ebmp/code/url.json`).then(response => {

            context.commit('SET_URL_DATA', response.data)
            resolve(response.data)

        }).catch(error => {
          console.log('==================== FETCH_URL error ====================')
          console.log(error.response)
          context.commit('SET_URL_ERROR', error.response)
        })
      })


    }
  }
};

export default urlStoreModule;
